export const Separator = () => <div className="border-b" />